import { Mail } from "lucide-react";

export const EMAIL = "services@crowlearn.com";

export function EmailLink({ subject, icon = false, className = "", children, testid = "email-link" }) {
  const href = `mailto:${EMAIL}${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`;
  return (
    <a href={href} data-testid={testid}
      className={`inline-flex min-h-[44px] items-center gap-1.5 rounded-sm font-medium text-[#222d99] underline underline-offset-4 hover:text-[#1a237e] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#222d99] ${className}`}>
      {icon && <Mail className="h-4 w-4 shrink-0" aria-hidden="true" />}
      {children || EMAIL}
    </a>
  );
}
